import React from "react";
import { CustomSectionPreview } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";

const CustomElement = ({ value, sectionId }) => {
  const wuiltContext = useElements();
  return (
    <CustomSectionPreview
      data={value}
      sectionId={sectionId}
      wuiltContext={wuiltContext}
    />
  );
};

export default CustomElement;
